import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react';
import { UNSAFE_DataRouterContext, useBlocker } from 'react-router-dom';
const Context = createContext(null);
function RouteGuard({ registry, en }) {
  const shouldBlock = useCallback(
    () => [...registry.current].some((r) => r.current.dirty || r.current.busy),
    [registry],
  );
  const blocker = useBlocker(shouldBlock);
  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    if ([...registry.current].some((r) => r.current.busy)) blocker.reset();
    else if (
      window.confirm(en ? 'Discard unsaved changes?' : '저장하지 않은 내용을 버리고 이동할까요?')
    )
      blocker.proceed();
    else blocker.reset();
  }, [blocker, registry, en]);
  return null;
}
export function ReviewDraftProvider({ children, en }) {
  const registry = useRef(new Set()),
    router = useContext(UNSAFE_DataRouterContext);
  return (
    <Context.Provider value={registry}>
      {router && <RouteGuard registry={registry} en={en} />}
      {children}
    </Context.Provider>
  );
}
export function useReviewDraft(dirty, busy, en) {
  const registry = useContext(Context),
    state = useRef({ dirty, busy });
  state.current = { dirty, busy };
  useLayoutEffect(() => {
    const set = registry?.current;
    set?.add(state);
    return () => set?.delete(state);
  }, [registry]);
  useEffect(() => {
    const protect = (e) => {
      if (state.current.dirty || state.current.busy) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', protect);
    return () => window.removeEventListener('beforeunload', protect);
  }, []);
  return () =>
    !state.current.busy &&
    (!state.current.dirty ||
      window.confirm(en ? 'Discard unsaved changes?' : '저장하지 않은 내용을 버릴까요?'));
}
export function useConfirmReviewDrafts(en) {
  const registry = useContext(Context);
  return () => {
    const entries = [...(registry?.current ?? [])];
    if (entries.some((r) => r.current.busy)) return false;
    return (
      !entries.some((r) => r.current.dirty) ||
      window.confirm(en ? 'Discard unsaved changes?' : '저장하지 않은 내용을 버릴까요?')
    );
  };
}

export function useReleaseReviewDrafts() {
  const registry = useContext(Context);
  return () => {
    for (const r of registry?.current ?? []) r.current = { dirty: false, busy: false };
  };
}
